import { useState } from "react"
import Button from "../../components/Button"
import InputText from "../../components/InputText"
import { playerLogin } from "../../services/players.services"
import { useAppDispatch } from "../../store/store"
import { toast } from "react-toastify"
import { setToken } from "../../store/features/tokenSlice"
import Header from "../../components/Header"
import Content from "../../components/Content"

const LoginPage = () => {
    const [data, setData] = useState<{ name: string, password: string }>({
        name: "",
        password: "",
    })
    const [requesting, setRequesting] = useState<boolean>(false)
    const dispatch = useAppDispatch()

    const handleInputChange: React.ChangeEventHandler<HTMLInputElement> = (event) => setData({ ...data, [event.target.name]: event.target.value })

    const handleSubmit: React.FormEventHandler<HTMLFormElement> = (event) => {
        event.preventDefault()
        setRequesting(true)

        playerLogin(data)
            .then((res) => {
                dispatch(setToken(res.data.payload.token))
                toast.success("¡Te has logueado correctamente!")
            })
            .catch((error) => toast.error(error.response.data.message))
            .finally(() => setRequesting(false))
    }

    return (
        <div className="flex flex-col">
            <Header className="flex flex-col gap-5 bg-[#46464c]">
                <p className="text-white font-extrabold uppercase text-4xl">Acceder</p>
            </Header>

            <Content className="flex justify-center">
                <form className="flex flex-col gap-5 max-w-[420px] w-full" onSubmit={handleSubmit}>
                    <InputText type="text" name="name" placeholder="Nickname" onChange={handleInputChange} />
                    <InputText type="password" name="password" placeholder="*****************" onChange={handleInputChange} />
                    <Button spinner={requesting} disabled={requesting}>Acceder</Button>
                </form>
            </Content>
        </div >
    )
}

export default LoginPage